import React, { memo, useEffect, useRef } from "react";
import Button from "../UI/Button";
import Icon from "../../../assets/icons/Icon";

const CommonModal = ({
  children,
  isShow,
  handleModalHide,
  modalTitle,
  isFooter = true,
  size = "xxl",
  backdrop = "static",
  isFixedHeight = false,
}) => {
  const modalRef = useRef(null);
  const isTop = true;
  // const backdrop = true;

  const handleBackdropClick = (e) => {
    if (backdrop === "static") return;
    if (e.target === e.currentTarget && backdrop !== "static" && isTop) {
      //   onClose();
      handleModalHide();
    }
  };

  useEffect(() => {
    const handleEsc = (e) => e.key === "Escape" && handleModalHide();
    document.addEventListener("keydown", handleEsc);
    return () => document.removeEventListener("keydown", handleEsc);
  }, []);

  return (
    <div
      className={`custom-modal-overlay is-visible `}
      onClick={handleBackdropClick}
      role="dialog"
      aria-modal={isTop}
    >
      <div
        className={`custom-modal custom-modal--${size} is-open ${isFixedHeight ? "fix-height" : ""} `}
        ref={modalRef}
        tabIndex={-1}
      >
        {true && (
          <div className="custom-modal__header">
            {/* {index > 0 && isTop && (
              <button className="custom-modal__back" onClick={() => {}}>
                <Icon name="arrow-left" />
              </button>
            )} */}
            <h5 className="custom-modal__title">{modalTitle}</h5>
            <button className="custom-modal__close" onClick={handleModalHide}>
              <Icon name="X" />
            </button>
          </div>
        )}

        <div className="custom-modal__body">{children}</div>
      </div>
    </div>
  );
};

export default memo(CommonModal);
